module.exports = __webpack_public_path__ + "img/yearly-sales.d5c58427.svg";